import {
  SystemOfMeasuresEnum,
  UserMeasurementWeightUnitType,
} from '@front-activerse/common-components';
import { goalSettings } from '../types';

const createFormikInitialValues = (goalSettingsData: any) => {
  const me = goalSettingsData.me;

  const goalSettings: goalSettings = {
    weightValue: me.lastMeasurement?.weight[0]?.value,
    weightUnit:
      me.systemOfMeasures === SystemOfMeasuresEnum.imperial
        ? UserMeasurementWeightUnitType.lb
        : UserMeasurementWeightUnitType.kg,
    goalWeightValue: me.goalWeight?.value,
    goalWeightUnit:
      me.systemOfMeasures === SystemOfMeasuresEnum.imperial
        ? UserMeasurementWeightUnitType.lb
        : UserMeasurementWeightUnitType.kg,
    dietMode: me.diet.mode,
    spontaneousActivityLevel: me.diet.spontaneousActivityLevel || 'low',
    activityLevel: me.diet.activityLevel || 'ACTIVITY_LEVEL_NONE',
    preferredMacronutrientRatio: me.diet.preferredMacronutrientRatio || {
      protein: 20,
      fat: 30,
      carbohydrate: 50,
    },
  };

  return goalSettings;
};

export default createFormikInitialValues;
